/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum EntitaCampoUtente {
    ORDINE_VENDITA = 0,
    ANAGRAFICA = 1,
    ORDINE_PRODUZIONE = 2,
    ARTICOLO = 3,
    ACCOUNT_ORGANIZZAZIONE = 4,
}
